import * as React from 'react';
import ConfirmationModal from 'components/Common/confirmationModal';
import './deleteUserModal.scss';

interface IDeleteUserModalProps {
    userCount: number;
    isProcessing: boolean;
    onCloseClick(): void;
    onCancelClick(): void;
    onConfirmClick(): void;
}

export class DeleteUserModal extends React.Component<IDeleteUserModalProps> {

    constructor(props: IDeleteUserModalProps) {
        super(props);
        this.handleCloseClick = this.handleCloseClick.bind(this);
        this.handleCancelClick = this.handleCancelClick.bind(this);
        this.handleConfirmClick = this.handleConfirmClick.bind(this);
    }

    render(): React.ReactNode {
        return (
            <ConfirmationModal
                className="delete-user-modal"
                message={this.renderModalBody()}
                onCancel={this.handleCancelClick}
                onClose={this.handleCloseClick}
                onConfirm={this.handleConfirmClick}
                title="Team manager users found"
                confirmMessage="Yes, Delete Users"
                cancelMessage="No, Keep Users"
                isCancelLink={false}
                isProcessing={this.props.isProcessing}
            />
        );
    }

    renderModalBody(): React.ReactNode {
        const { userCount } = this.props;

        return (
            <div className="delete-user-modal__body">
                {`${userCount} Employees who are being removed are managers and are listed Team users within your account.
                Would you like to delete their user access as well?`}
            </div>
        );
    }

    handleCloseClick(): void {
        this.props.onCloseClick();
    }

    handleCancelClick(): void {
        this.props.onCancelClick();
    }

    handleConfirmClick(): void {
        this.props.onConfirmClick();
    }
}

export default { DeleteUserModal };